// Cálculos puros de estoque da Lojinha, extraídos da UI para permitir teste
// direto (o projeto não tem render tests) e evitar divergência entre telas.

export const availableStock = variation => {
  const { quantity, quantity_sold } = variation || {}
  const stock = (quantity || 0) - (quantity_sold || 0)
  return stock > 0 ? stock : 0
}

// Teto do stepper de quantidade: o menor entre o estoque disponível e o limite
// máximo permitido para a variação.
export const stepperAvailableQuantity = variation => {
  if (!variation) return 0
  const { max_quantity } = variation
  const stock = availableStock(variation)
  if (max_quantity == null) return stock
  return Math.min(stock, max_quantity)
}

// Estoque não cadastrado (`quantity` nulo) conta como esgotado: é o que o
// `available_quantity` do servidor já faz, e a listagem espelha essa definição.
/**
 * @param {{ quantity?: number, quantity_sold?: number }} [variation]
 * @returns {boolean}
 */
export const isSoldOut = ({ quantity, quantity_sold } = {}) =>
  (quantity_sold || 0) >= (quantity || 0)

// Estoque baixo: fração vendida atingiu o limiar (default 75%). Retorna false
// quando não há quantidade definida (evita NaN).
export const isLowStock = ({ quantity, quantity_sold } = {}, threshold = 0.75) => {
  if (!quantity) return false
  return (quantity_sold || 0) / quantity >= threshold
}
